// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoContainer[data-v-7cc183fa]{padding:10px}.infoContainer .top p[data-v-7cc183fa]{text-align:center;margin:0}.infoContainer .top .smallTxt[data-v-7cc183fa]{font-size:12px}.infoContainer .left .van-button[data-v-7cc183fa],.infoContainer .right .van-button[data-v-7cc183fa]{margin:0 0 10px}.infoContainer .van-cell[data-v-7cc183fa]{border:1.5px solid #3f9775;padding:4px 16px;border-radius:8px;box-shadow:inset 0 0 5px 0 #969799}[data-v-7cc183fa]:export{green:#3f9775;white:#fff}", ""]);
// Exports
module.exports = exports;
